
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ProductForm__Variants').forEach(function (container) {
    var children = Array.prototype.slice.call(container.children).filter(function (el) {
      return el.classList.contains('ProductForm__Option');
    });

    var i = 0;
    while (i < children.length) {
      var isMulti = function (el) {
        return el.querySelectorAll('.HorizontalList__Item').length > 1;
      };

      if (isMulti(children[i])) {
        var group = [children[i]];
        var j = i + 1;
        while (j < children.length && isMulti(children[j])) {
          group.push(children[j]);
          j++;
        }

        if (group.length > 1) {
          var wrapper = document.createElement('div');
          wrapper.className = 'olfa-fragrance-group';
          group[0].parentNode.insertBefore(wrapper, group[0]);
          group.forEach(function (el) {
            wrapper.appendChild(el);
          });
        }
        i = j;
      } else {
        i++;
      }
    }
  });
});